module.exports = __webpack_public_path__ + "static/media/coolicon.223469d0.svg";